module.exports = __webpack_public_path__ + "static/media/no-candidate-1500.4d916a4b.jpg";